import React from "react"
import { Link } from "react-router-dom"
import GlobalHelper from "../GlobalHelper.jsx"
import "./tabs.scss"

type Tab = {
    name: React.ReactNode,
    link: string,
    hidden?: boolean,
    restrictedIntegrations?: string[]
}

type OwnProps = {
    value: Tab[]
}

const Tabs = (props: OwnProps) => {
    return (
        <div>
            <div className="d-block d-sm-none custom-mt-6">
            </div>
            <div className="d-none d-block mt-5">
                <div className="d-flex flex-row justify-content-start pt-2 fixed-top tabs-menu bg-light">
                    <div className="box-shadow p-2 d-none d-xl-inline-block " style={{ width: "65px" }} />
                    <div>
                        <nav className="ml-3 my-2 my-md-0 mr-md-3 text-center text-dark">
                            {props.value.filter(m => {
                                if (m.hidden || GlobalHelper.hasIntegrations(m.restrictedIntegrations || [])) {
                                    return false
                                }
                                return true
                            }).map((m, i) => {
                                let active = ""
                                if (m.link === location.pathname) {
                                    active = " active"
                                }
                                return <div key={"div" + i} className={"d-inline-flex pb-1 " + active} style={{ marginBottom: "-3px" }}>
                                    <Link key={i} className={"px-4 text-dark "} to={m.link}>{m.name}</Link>
                                </div>
                            })}
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Tabs


// WEBPACK FOOTER //
// ./src/common/layout/tabs.component.tsx